"use strict";

require("core-js/modules/es6.object.freeze");

require("core-js/modules/es6.array.some");

require("core-js/modules/es7.array.includes");

require("core-js/modules/es6.string.includes");

require("core-js/modules/es6.array.for-each");

require("core-js/modules/es6.array.find");

require("core-js/modules/es6.regexp.replace");

require("core-js/modules/es6.regexp.split");

require("core-js/modules/es6.array.index-of");

require("core-js/modules/es6.array.filter");

require("core-js/modules/es6.array.is-array");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.array.from");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.date.to-string");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.array.from");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.date.to-string");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.is-array");

require("core-js/modules/es6.object.freeze");

require("core-js/modules/es6.array.some");

require("core-js/modules/es7.array.includes");

require("core-js/modules/es6.string.includes");

require("core-js/modules/es6.array.for-each");

require("core-js/modules/es6.array.find");

require("core-js/modules/es6.regexp.replace");

require("core-js/modules/es6.regexp.split");

require("core-js/modules/es6.array.index-of");

require("core-js/modules/es6.array.filter");

var _cssClasses = _interopRequireDefault(require("../helpers/cssClasses"));

var _utils = require("../helpers/utils");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }
}
/**
 * DOM selectors.
 */


var selectors = {
  optionsList: '[js-product-form="options"]',
  footer: '[js-product-form="footer"]',
  toggleSelector: '[js-product-swatches="toggle"]',
  productData: 'product',
  publishedDateContainer: '.product-form_published_date',
  isbnContainerWrapper: '.product-form_isbn',
  isbnContainer: '.product-form_isbn_container',
  ebook: '[js-product-links="container"]',
  quantitySelector: '[js-quantity-selector="container"]',
  quantitySelectorInput: '[js-quantity-selector="input"]',
  variantValue: '[js-option-value]',
  ebookAlert: '[js-product-form="ebookAlert"]'
};
/**
 * Export a new product swatch object.
 */

var _default = function _default() {
  var nodeSelectors = {
    optionsList: document.querySelector(selectors.optionsList),
    footer: document.querySelector(selectors.footer),
    toggleSelector: document.querySelectorAll(selectors.toggleSelector),
    productData: document.getElementById(selectors.productData),
    publishedDateContainer: document.querySelector(selectors.publishedDateContainer),
    isbnContainerWrapper: document.querySelector(selectors.isbnContainerWrapper),
    isbnContainer: document.querySelector(selectors.isbnContainer),
    ebook: document.querySelector(selectors.ebook),
    quantitySelector: document.querySelector(selectors.quantitySelector),
    quantitySelectorInput: document.querySelector(selectors.quantitySelectorInput),
    variantValues: document.querySelectorAll(selectors.variantValue)
  };

  function getProductJSON() {
    return JSON.parse(nodeSelectors.productData.innerHTML);
  }

  function getVariantPublishTags() {
    var productJSON = getProductJSON();
    var productPublishTags = productJSON.tags.filter(function (item) {
      return item.indexOf('pubdate') !== -1;
    });
    return productPublishTags;
  }

  function getVariants() {
    var productJSON = getProductJSON();
    return productJSON.variants;
  }
  /**
   * Initialise component.
   */


  function init() {
    setToggleEvents();
    initProductLinks();
    initEbookAlert();
  }

  function processDateTag(tag) {
    var tagClean = tag.split('-').slice(1).join('/');
    var getMonth = tagClean.slice(3, 5);
    var getYear = tagClean.slice(5).replace('/', '');
    var getMonthString = processMonth(getMonth);
    var dateConcat = "".concat(getMonthString, " ").concat(getYear);
    return dateConcat;
  }

  function processMonth(month) {
    switch (month) {
      case '01':
        return 'January';

      case '02':
        return 'February';

      case '03':
        return 'March';

      case '04':
        return 'April';

      case '05':
        return 'May';

      case '06':
        return 'June';

      case '07':
        return 'July';

      case '08':
        return 'August';

      case '09':
        return 'September';

      case '10':
        return 'October';

      case '11':
        return 'November';

      default:
        return 'December';
    }
  }

  function updateIsbn(selectedOption, variants) {
    var selectedVariant = variants.find(function (item) {
      return item.title === selectedOption;
    });
    nodeSelectors.isbnContainerWrapper.classList.remove(_cssClasses["default"].hidden);
    nodeSelectors.isbnContainer.innerHTML = selectedVariant.sku;
  }
  /**
   * Set listeners.
   */


  function setToggleEvents() {
    _toConsumableArray(nodeSelectors.toggleSelector).forEach(function (element) {
      (0, _utils.on)('click', element, function (event) {
        var selectedOption = element.getAttribute('value');
        paperbackCheck(element);
        updateEbooklinks(selectedOption);
        toggleEbookAlert(selectedOption);
        updateIsbn(selectedOption, getVariants());
        event.preventDefault();
        toggleOption(event.currentTarget);
      });
    });
  }
  /**
   * Enable quantity selector on Paperback option.
   */


  function paperbackCheck(element) {
    var optionValue = element.getAttribute('value').toLowerCase();

    if (optionValue === 'paperback') {
      nodeSelectors.quantitySelector.classList.add(_cssClasses["default"].active);
      nodeSelectors.quantitySelectorInput.removeAttribute('disabled');
    } else {
      nodeSelectors.quantitySelector.classList.remove(_cssClasses["default"].active);
      nodeSelectors.quantitySelectorInput.setAttribute('disabled', 'disabled');
    }
  }
  /**
   * Toggle selected option.
   * @param {Node} target - DOM node from clicked event.
   */


  function toggleOption(target) {
    var element = target.parentNode;
    var siblings = (0, _utils.getSiblings)(element);
    element.classList.add(_cssClasses["default"].active);
    removeToggled(siblings);
  }
  /**
   * Remove toggle from non-targeted elements.
   */


  function removeToggled(elements) {
    _toConsumableArray(elements).forEach(function (element) {
      if (element.classList.contains(_cssClasses["default"].active)) {
        element.classList.remove(_cssClasses["default"].active);
      }
    });
  }

  function updateEbooklinks(selectedValue) {
    if (nodeSelectors.ebook) {
      if (selectedValue.toLowerCase().includes('book')) {
        nodeSelectors.ebook.classList.add(_cssClasses["default"].active);
      } else {
        nodeSelectors.ebook.classList.remove(_cssClasses["default"].active);
      }
    }
  }
  /**
   * Returns an array with the ID of each variant of the product.
   */


  function variantsIDs() {
    var productIDs = [];

    _toConsumableArray(nodeSelectors.variantValues).forEach(function (option) {
      if (!option.dataset.ebookId) {
        return;
      }

      productIDs.push(option.dataset.ebookId);
    });

    return productIDs;
  }
  /**
   * Checks if the ebook in the PDP page has been ordered before.
   */


  function ebookOrdered() {
    if (!window.orderedBooks) {
      return false;
    }

    return window.orderedBooks.some(function (order) {
      return variantsIDs().includes(order);
    });
  }
  /**
   * Generates the ebook alert box if the ebook has been bought and shows it
   * if the variant is only one and it's the ebook.
   */


  function initEbookAlert() {
    if (!ebookOrdered()) {
      return;
    }

    var ebookAlert = document.createElement('div');
    ebookAlert.setAttribute('js-product-form', 'ebookAlert');
    ebookAlert.setAttribute('class', "ebook-alert ".concat(_cssClasses["default"].hidden));
    var alertContent = "\n      <p>\n        ".concat(window.theme.strings.ebooks.ebookAlertPDP, "\n      </p>\n      <a class=\"button button--primary\" href=\"/account?view=ebooks\">\n        ").concat(window.theme.strings.ebooks.ebookAlertButton, "\n      </a>\n    ");
    ebookAlert.innerHTML = alertContent;
    nodeSelectors.optionsList.appendChild(ebookAlert);

    if (nodeSelectors.variantValues.length < 2 && nodeSelectors.variantValues[0]) {
      toggleEbookAlert(nodeSelectors.variantValues[0].value);
    }
  }
  /**
   * Toggle the visibility of the alert box if the variant is selected.
   * @param {string} selectedValue - Value of option cta.
   */


  function toggleEbookAlert(selectedValue) {
    var ebookAlert = document.querySelector(selectors.ebookAlert);

    if (ebookAlert) {
      if (selectedValue.toLowerCase().includes('book')) {
        nodeSelectors.footer.classList.add(_cssClasses["default"].hidden);
        ebookAlert.classList.remove(_cssClasses["default"].hidden);
      } else {
        nodeSelectors.footer.classList.remove(_cssClasses["default"].hidden);
        ebookAlert.classList.add(_cssClasses["default"].hidden);
      }
    }
  }
  /**
   * Get the value of the selected variant. Then enable/disbale product links.
   */


  function initProductLinks() {
    if (nodeSelectors.variantValues[0]) {
      updateEbooklinks(nodeSelectors.variantValues[0].value);
    }
  }
  /**
   * Expose public interface.
   */


  return Object.freeze({
    init: init
  });
};

exports["default"] = _default;